import { T } from 'src/shared/helpers';

/** Keep material labels consistent between product setup and the assistant's draft preview. */
export const getResizableMaterialName = (presetID: number, name?: string | null): string => {
    const names: Record<number, string> = {
        1: T._('Light wood', 'Admin'),
        2: T._('Medium wood', 'Admin'),
        3: T._('Dark Wood', 'Admin'),
        4: T._('White Marble', 'Admin'),
        5: T._('Grey Marble', 'Admin'),
        6: T._('Canvas', 'Admin'),
        7: T._('Leather', 'Admin'),
        8: T._('Plexiglass', 'Admin'),
        9: T._('Brushed Metal', 'Admin')
    };
    return names[presetID] || name?.trim() || T._('Material', 'Admin');
};
